import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Section } from '../..';

const EducationHistory = ({ field, translations }) => {
    const getLabel = ({ startDate, finishDate, stillStudy }) => `${moment(startDate).format('MMMM YYYY')} - ${stillStudy ? translations.present : moment(finishDate).format('MMMM YYYY')}`;
    const getDesc = ({ schoolTypeName, educationLevelName, specializationStudyName }) => {
        const schoolTypeCondition = schoolTypeName ? `${schoolTypeName}${', '}` : '';
        const educationLevelCondition = educationLevelName ? `${educationLevelName}` : '';
        const specializationStudyCondition = specializationStudyName ? `${specializationStudyName}` : '';

        return `${schoolTypeCondition}${educationLevelCondition}
        ${specializationStudyCondition}`;
    };

    return (
        <Section.Conditional
            condition={Boolean(field.value.length)}
            title={translations.educationHistory}
        >
            {({ renderField }) => (
                <>
                    {field.value.map(
                        (school) => renderField(getLabel(school), getDesc(school), null, `school_${school.id}`)
                    )}
                </>
            )}
        </Section.Conditional>
    );
};
EducationHistory.propTypes = {
    field: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default EducationHistory;
